/* Copied from prototype/model.html by tools/port-model.py. */
import { mountCup } from './cup3d.js';

/* The models exported so far. This has to match assets/models/. */
/* Read off assets/models when silhouettes.js was generated, rather than kept by
   hand here. The hand-kept list said six models on 21 Aug 2026 while twelve
   exports sat in the folder, so KUBO, TOMMA, EKKO, OKKO, TOSHI and TOTO were all
   quietly turning LILO on their own pages. David: "now that we have all of the
   cups icons, there is no reason to keep using the glb placeholder of the lilo.
   each unique cup should have it's unique glb preview". */
var HAS_GLB = window.ODAKA_HAS_GLB || [];

var m = window.ODAKA_MODEL;
/* One square of the drawn grid, in millimetres: KUBO's 82.8 mm over the 7
   bands its 6 rings make. See the rings option below.

   Published, because a swap has to work the count out for the model it is
   stepping to and that code is not in this module. One rule, one place. */
var RING_MM = 82.82 / 7;
window.ODAKA_RINGS_FOR = function (heightMm) {
  return Math.max(2, Math.round(heightMm / RING_MM) - 1);
};

var slug = window.ODAKA_SLUG(m.name);

/* A model with no export of its own turns LILO instead. David asked on 16 Aug
   2026 for the stand-ins to sit on the same grid and the same ground as the
   rest, and this is that rather than an imitation of it: the flat silhouette
   they used to show WAS the LILO profile already, so putting them through the
   same three.js drawing gives the identical line work, the identical ring and
   meridian grid, and the identical ground line, for nothing.

   Nothing is being claimed by this. The page still says plainly that the shape
   is a stand-in, and it still withholds the height, which would be LILO's. The
   volume stays, because that is a true fact about the model whatever its shape.

   The day a model is exported, adding its slug to HAS_GLB above and dropping
   the .glb into assets/models/ is the whole change. */
/* The compressed copies, David 23-10-2026: assets/models-web/ is what the
   site downloads, a quarter or less of assets/models/, which stays as it was
   because the Blender renders read it. tools/compress-models.sh makes one from
   the other; run it after any new export. */
var url = window.ODAKA_ASSET((HAS_GLB.indexOf(slug) >= 0 ? slug : 'lilo') + '.glb');

{
  var cup = document.getElementById('cup');

  /* --mm is a min() of three limits, so it cannot be read off the element as a
     number. Measure it instead: a hundred of them, divided by a hundred. */
  var probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;visibility:hidden;height:calc(var(--mm) * 100)';
  cup.appendChild(probe);
  var pxPerMm = probe.getBoundingClientRect().height / 100;
  probe.remove();

  var svg = cup.querySelector('svg');
  var canvas = document.createElement('canvas');
  cup.appendChild(canvas);
  cup.classList.add('live');
  svg.style.display = 'none';

  window.ODAKA_CUP = mountCup(canvas, {
    url: url,
    mm: m.mm,
    pxPerMm: pxPerMm,
    /* The cup keeps its own warm brown and the PAGE went cream around it.
       David, 13 Sep 2026: "i wanted the cup glb to be the warm brown color it
       was, only the background to change to the lighter cream color."

       This one value does it, and it took a wrong turn to see why. The body is
       filled with --ground and it used to VANISH, because the viewer behind it
       was --ground too - all that showed was the white line work. Now the viewer
       is paper, the same fill stops disappearing and becomes the cup: a warm
       brown mass standing on cream, with its own lines still white on it.

       So the drawing did not need flipping to ink at all. It needed the page
       moved out from under it. */
    ground: '#ddbea9',        /* --ground, and now it is the cup rather than the air */
    /* Seven, which is what the glb Viewer uses. It was dropped to four while
       the lid was being chased and David spotted the loss straight away: the
       grid at the beginning was better. The meridians follow from this number,
       so it is the one dial for how fine the drawing is. */
    /* How fine the drawing is, and it comes from the cup's own height rather
       than being one number for every model.

       Cups are drawn at TRUE size here, so a fixed ring count gave a taller cup
       bigger squares: at 6 rings TOSHI's bands were 15.8 mm and EMMA's 8.2 mm,
       near enough double. David saw it on 13 Sep 2026 - "if the model is larger,
       it needs more rings, right?" - and it is the right way round: to hold one
       square across the range, a taller cup takes more rings.

       RING_MM is that square, and it is set by the one David chose by eye: 6 on
       KUBO, which is 82.8 mm over 7 bands. Everything else follows from it, so
       there is no list to keep in step with the catalogue and a new model sizes
       itself. The counts it gives, which are the ones he approved:

         8  TOSHI                                   7  YUNO
         6  KUBO, LUKKA-L, LOU, TOMMA, LUKKA        5  GLOBE-M, GLOBE-S, OKKO, TOTO, LILO
         4  EKKO, EMMA

       Rings are bands minus one, and the floor of 2 is there so nothing can ask
       for a grid with no lines in it. The meridian count follows the ring
       spacing inside the module, so the cells stay square on their own. */
    rings: window.ODAKA_RINGS_FOR(m.mm),
    /* The meridians carry on over the lip and down the inner wall, and the
       inside is ruled at the SAME spacing as the outside rather than twice as
       close. Both are this one switch, and David asked for both on 13 Sep
       2026: "can we see the glb with the vertical lines curve into the inside?
       i wonder if it looks better", then, having seen it on LILO, "ok. i think
       it looks better" and "make the spacing inside the cup same as outside".

       This reverses two earlier calls of his, and the reasons they were made
       have gone. The mouth was left empty on 16 Aug 2026 - "the side is right,
       the top is not" - when the meridians ran over an unrebuilt lip; and the
       inner rings were doubled up on 17 Aug 2026 to give the inside something
       to read when it had no verticals of its own. It has them now.

       Only the model page. The Explore grid and the collections viewer mount
       the same module and still take its default, which is rings inside and
       nothing else. */
    inside: true,
    /* ⚠️ A TRIAL, ON LILO ONLY. The inner lip line one step back: a full
       millimetre down, on the inner wall, reading as a ring all round the
       cup - against every other model's 0.1 mm, which puts it up at the rim.
       David, 13 Sep 2026: "i want to see it back (the step earlier). i'm
       having hard time to decide". Compare LILO against LOU or LUKKA, which
       are on the same 7 rings, rather than against KUBO or EMMA.
       Take this line out once he has chosen. */
    lipIn: slug === 'lilo' ? 1.0 : undefined,
    /* No cap on the meridians, anywhere. GLOBE-M was held at 28 lines and
       TOSHI at 18 for a few hours on 13 Sep 2026, and both were a mistake of
       the same kind: a cap is what stops the cells being square, which is
       exactly what David then saw on GLOBE-M - "now it's not squares".

       The thing the caps were reaching for cannot be had. One square size
       across every piece MEANS a bowl carries twice a cup's verticals, because
       it is twice around; taking the count from the average radius instead of
       the widest moves every model by a fifth and leaves the gap untouched.
       Square cells or comparable counts - not both.

       David chose square, 13 Sep 2026. So a bowl is dense because a bowl is
       big, and that is the drawing telling the truth. `maxSpokes` stays in
       cup3d.js as a dial, unused, in case the bowls later want a coarser
       square of their own - which is the one exception that would not need
       per-model tuning. */
    onFail: function (e) {    /* fall back to the drawing rather than to a hole */
      canvas.remove();
      cup.classList.remove('live');
      svg.style.display = 'block';   /* not '', see the .cup svg rule */
      if (window.console) console.warn('cup3d: falling back to the silhouette', e);
    }
  });

  /* ---------- waiting for the cup ----------
     Polled rather than pushed. This used to hang off an onReady callback added
     to cup3d.js, but that file is being worked on in a second session and the
     callback was lost when their copy was saved over it - taking the cup with
     it, since nothing then brought it on screen. So the page no longer asks
     that file for anything it does not already offer: `info.dims` is set the
     moment the drawing exists, and watching for it costs one rAF a frame for
     under a second.

     Everything below is what onReady used to do. */
  var handle = window.ODAKA_CUP;
  var arrived = false;
  var waitFrom = performance.now();

  function cupHasLanded() {
    if (arrived) return;
    arrived = true;
    cup.classList.add('risen');

    /* The type starts the moment the cup has ARRIVED, which is earlier than the
       moment its transition ends. The curve is a quartic ease-out, so the cup
       covers 95% of its distance in the first 53% of the time and then creeps
       the last few pixels home; waiting for transitionend left it looking parked
       for about 300ms. Read off the element's own duration, so retuning the cup
       retunes this with it. ARRIVED is the one dial.

       transitionend stays as a backstop, and the timer covers having no
       transition to end at all, which is what a hidden tab and reduced motion
       both look like. */
    var ARRIVED = 0.53;
    var dur = parseFloat(getComputedStyle(canvas).transitionDuration) * 1000 || 700;
    var fired = false;
    var done = function () {
      if (fired) return;
      fired = true;
      canvas.removeEventListener('transitionend', onEnd);
      if (window.ODAKA_RISE) window.ODAKA_RISE();
    };
    var onEnd = function (e) { if (e.propertyName === 'transform') done(); };
    canvas.addEventListener('transitionend', onEnd);
    setTimeout(done, dur * ARRIVED);
    setTimeout(done, 900);
  }

  (function watch() {
    if (handle && handle.info && handle.info.dims) { cupHasLanded(); return; }
    /* Give up quietly after a few seconds. The type has its own safety net, and
       the silhouette has a timer of its own, so nothing is left blank. */
    if (performance.now() - waitFrom > 4000) return;
    requestAnimationFrame(watch);
  })();

}

/* ---------- the name stops at the line ----------
   Registered once, outside paint(), like the swipe and the caption strip.
   paint() only tells it the model has changed. See .name-dock in the CSS for
   what this is and why it is a second copy rather than `position: sticky`. */
(function () {
  /* Only the NAME stays, and it takes the drink's place in the strip's row:
     160 ML / 5.4 OZ, EKKO, PIECES 7. David, 24 Sep 2026: "I want the DRINK
     to disappear and let only the MODEL name to keep scrolling down with us",
     then "i want the MODEL name to stop on the same line where we have the
     volume and pieces". The drink stops with the volume and the height and
     the strip rises over all three, right up under the bar.

     Until that day the drink stayed pinned under the name and the strip's
     row lined up with the drink. That version is kept, whole, in
     PINNED-DRINK.md beside this file, with how to bring it back. */

  var h1 = document.getElementById('model-name');
  var drink = document.getElementById('model-drink');
  var box = document.getElementById('name-dock');
  var ndName = document.getElementById('nd-name');
  var ndDrink = document.getElementById('nd-drink');
  var volume = document.getElementById('model-volume');
  var sub = document.getElementById('model-sub');
  var figs = document.getElementById('figs-dock');
  var ndVolume = document.getElementById('nd-volume');
  var ndSub = document.getElementById('nd-sub');
  var strip = document.querySelector('.dock');
  if (!h1 || !drink || !box || !ndName || !ndDrink) return;
  if (!volume || !sub || !figs || !ndVolume || !ndSub || !strip) return;

  var lock = 0;
  var hasFigs = false;
  var viewer = document.querySelector('.viewer');
  var dockVolume = document.getElementById('dock-volume');
  var inkCtx = document.createElement('canvas').getContext('2d');

  /* The middle of the capitals, which is what "on the same level" means for
     two lines of different sizes. A text box is centred on room for
     descenders capitals do not use, so boxes would put the 12px drink and the
     10px volume a pixel or two apart. */
  function ink(el) {
    var cs = getComputedStyle(el);
    inkCtx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var m = inkCtx.measureText((el.textContent || 'H').toUpperCase());
    var base = textRect(el).top + m.fontBoundingBoxAscent +
      (textRect(el).height - m.fontBoundingBoxAscent - m.fontBoundingBoxDescent) / 2;
    return { top: base - m.actualBoundingBoxAscent, bottom: base + m.actualBoundingBoxDescent };
  }
  function inkMiddle(el) { var i = ink(el); return (i.top + i.bottom) / 2; }

  /* On a phone the strip's top line is scrubbed by the scroll rather than
     timed. David, 16 Sep 2026: it "begins to shrink" once the volume has gone
     under the strip, and "completes shrink and disappear 5 px before touching"
     what is pinned above it - the drink then, the name since 24 Sep. Both are
     strip positions on screen, measured off the ink: scrubFrom is the
     volume's top, scrubTo is 5px below the name's foot. */
  var phone = window.matchMedia('(max-width: 767px)');
  var scrubFrom = 0, scrubTo = 0;

  /* The volume and the height sit inside the masks that make them rise on
     arrival, and a line still mid-rise is displaced by its transform. The mask
     itself never moves, so it is the one to measure. */
  function lineBox(el) {
    var p = el.parentNode;
    return (p && p.classList.contains('mask') ? p : el).getBoundingClientRect();
  }

  /* Where the WORD is, not where its box is. The h1 is a block: its rect is the
     full width of the column with the name centred inside it, so measuring the
     box instead of the letters puts the lock in the wrong place. */
  function textRect(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    var box = r.getBoundingClientRect();
    return box.height ? box : el.getBoundingClientRect();
  }

  function measure() {
    ndName.textContent = h1.textContent;
    var d = drink.textContent.trim();
    ndDrink.textContent = d;
    /* The drink's copy rides with the figures, which stop and go under the
       strip. A model with no drink named has nothing to carry there. */
    ndDrink.hidden = !d;

    var was = box.style.visibility;
    box.style.visibility = 'hidden';

    box.style.paddingBottom = '';
    box.style.paddingTop = '';
    box.style.backgroundSize = '';
    /* The strip parks with its row level with the NAME, so the name's ink
       middle has to sit at least as far down the band as the strip's words
       sit down the strip. If it does not, the band grows at the top by the
       difference - before the lock is measured below. */
    var inStrip = inkMiddle(dockVolume) - strip.getBoundingClientRect().top;
    var short = inStrip - (inkMiddle(ndName) - box.getBoundingClientRect().top);
    if (short > 0) {
      box.style.paddingTop = ((parseFloat(getComputedStyle(box).paddingTop) || 0) + short).toFixed(2) + 'px';
    }
    /* And it must end ABOVE the drink, or its ground (which sits over the
       figures' copy) cuts the top off the drink's letters while the name is
       pinned: 2px above the drink's capitals, measured off the real ident. */
    if (!ndDrink.hidden) {
      var gap = ink(drink).top - ink(h1).bottom;
      var want2 = ink(ndName).bottom + gap - 2;
      var pb = parseFloat(getComputedStyle(box).paddingBottom) || 0;
      box.style.paddingBottom = Math.max(0, pb + want2 - box.getBoundingClientRect().bottom).toFixed(2) + 'px';
    }

    var T = textRect(ndName);
    var H = textRect(h1);

    /* It locks when the real name's middle reaches the copy's middle, so the
       swap happens with the two exactly on top of each other. */
    lock = (H.top + window.scrollY + H.height / 2) - (T.top + T.height / 2);

    /* Where the caption strip parks, as an offset below the bar: its words
       level with the name's, so the three read as one row. The offset is the
       name's ink middle less how far the volume's ink sits inside the strip.

       A model with no drink (the Others) needs nothing different. The one
       risk it used to carry - OMI's name read through by what scrolled
       behind it, David 21 Sep 2026, because a strip parked level with the
       name left the band almost no ground - is closed by update() below,
       which keeps the band's ground full until the strip itself arrives. */
    var band = box.getBoundingClientRect();
    var ident = inkMiddle(ndName) - band.top - inStrip;
    document.documentElement.style.setProperty('--ident-dock',
      Math.max(0, ident).toFixed(2) + 'px');

    /* The figures' copy: the same words, hung from the foot of the name band
       and pushed down until each line is exactly as far below the name as the
       real one is. Box to box on both sides, so the metrics cancel. */
    ndVolume.textContent = volume.textContent.trim();
    ndSub.textContent = sub.textContent.trim();
    var drinkInFigs = !ndDrink.hidden;
    hasFigs = !!(ndVolume.textContent || ndSub.textContent || drinkInFigs);
    ndSub.hidden = !ndSub.textContent;
    if (hasFigs) {
      figs.style.top = box.getBoundingClientRect().bottom + 'px';
      ndVolume.style.marginTop = ndSub.style.marginTop = '0px';
      var name = h1.getBoundingClientRect();
      var copy = ndName.getBoundingClientRect();
      /* The drink first when it is down here, since the volume is measured
         from wherever the drink leaves it. */
      if (drinkInFigs) {
        ndDrink.style.marginTop = '0px';
        ndDrink.style.marginTop = ((lineBox(drink).top - name.top) -
          (ndDrink.getBoundingClientRect().top - copy.top)).toFixed(2) + 'px';
      }
      ndVolume.style.marginTop = ((lineBox(volume).top - name.top) -
        (ndVolume.getBoundingClientRect().top - copy.top)).toFixed(2) + 'px';
      if (!ndSub.hidden) {
        ndSub.style.marginTop = ((lineBox(sub).top - lineBox(volume).top) -
          (ndSub.getBoundingClientRect().top - ndVolume.getBoundingClientRect().top)).toFixed(2) + 'px';
      }
    }

    var above = ink(ndName);
    /* The line is the pixel above the strip's top, so +6 finished it 5px clear
       of the name. +10 since David, 24 Sep 2026: "finish animation about 3-4
       px earlier", so it is gone 9px clear. */
    scrubTo = above.bottom + 10;

    /* The line starts to shrink only once the volume under the name has gone
       completely under the strip: the strip's top reaching the volume's ink
       top. David, 24 Sep 2026: "The line should start shrinking only the
       second volume text disappears". From 16 Sep until then it began 11px
       earlier, while the volume's last 10px were still going under ("start
       shrinking a slight bit earlier", and "1 px earlier"). */
    scrubFrom = hasFigs ? ink(ndVolume.textContent ? ndVolume : ndSub).top
                        : box.getBoundingClientRect().bottom;

    box.style.visibility = was;
    update();
  }

  function update() {
    var on = window.scrollY >= lock;
    /* visibility, not display: the real pair keeps its place in the ident so
       the volume and the height below it do not jump when the pair hides. */
    h1.style.visibility = on ? 'hidden' : '';
    drink.style.visibility = on ? 'hidden' : '';
    box.style.visibility = on ? 'visible' : 'hidden';

    var figsOn = on && hasFigs;
    volume.style.visibility = figsOn ? 'hidden' : '';
    sub.style.visibility = figsOn ? 'hidden' : '';
    figs.style.visibility = figsOn ? 'visible' : 'hidden';

    viewer.classList.toggle('docked', on);
    /* The line starts to go as the strip nears the name, not once it has
       stopped, or it would be drawn straight through the name on the way. */
    var stripTop = strip.getBoundingClientRect().top;
    var lineShowing = true;
    if (phone.matches) {
      strip.classList.remove('parked');
      var span = scrubFrom - scrubTo;
      var k = !on ? 1 : span > 0 ? Math.min(1, Math.max(0, (stripTop - scrubTo) / span)) : 0;
      /* The dot takes over once the line is under 2px wide, and holds one
         pixel of scroll past the point the line reaches nothing. */
      var dot = on && k * strip.offsetWidth < 2 && stripTop > scrubTo - 1;
      strip.style.setProperty('--line', dot ? '0' : k.toFixed(4));
      strip.style.setProperty('--dot', dot ? '1' : '0');
      lineShowing = dot || k > 0;
    } else {
      strip.style.removeProperty('--line');
      strip.style.removeProperty('--dot');
      var parkAt = box.getBoundingClientRect().top + box.offsetHeight;
      strip.classList.toggle('parked', on && stripTop <= parkAt + 0.5);
    }
    /* The strip rises INTO the name's band, so the band's ground cannot be a
       fixed height: full while the strip is below it, and ending at the
       strip's top once it arrives, so it never covers the strip's words.

       ⚠️ While the strip's top line or its closing dot is still showing, the
       ground stops 2px ABOVE the strip. Both are drawn just over the strip's
       top edge, the band sits above the strip, and a ground reaching the
       strip hid the end of the shrink and the whole dot - David spotted it
       the same day, 24 Sep 2026: "i don't see that animation anymore". Once
       they have gone it closes to one pixel of overlap, explained at
       .name-dock, so there is never a hole between the two. */
    var bandTop = box.getBoundingClientRect().top;
    var ground = Math.max(0, Math.min(box.offsetHeight,
      stripTop - bandTop + (on && lineShowing ? -2 : 1)));
    box.style.backgroundSize = '100% ' + ground.toFixed(2) + 'px';
    if (figsOn) {
      /* Cut at the strip's line: whatever of the figures lies below it is gone. */
      var f = figs.getBoundingClientRect();
      var below = Math.max(0, f.bottom - strip.getBoundingClientRect().top);
      figs.style.clipPath = below ? 'inset(0 0 ' + Math.min(below, f.height) + 'px 0)' : '';
    }
  }

  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; update(); });
  }, { passive: true });
  addEventListener('resize', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

  /* paint() calls this once it has written the new model's name and drink. */
  window.ODAKA_NAME_DOCK = measure;
  measure();
})();
